import './main.vendors';
import './main.auth';
import './main.filters';
import AuthService from './services/AuthService';
import Vue from 'vue';
import App from '@/containers/App';
import router from './main.router';
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import MaterialDashboard from "./material-dashboard";
import vuetify from './plugins/vuetify';
import CKEditor from '@ckeditor/ckeditor5-vue';

import "vue-material/dist/vue-material.min.css";
import "./assets/scss/material-dashboard.scss";
import 'vue2-timepicker/dist/VueTimepicker.css';

import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
dayjs.extend(customParseFormat)

import store from "@/store";

Vue.config.productionTip = false
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(CKEditor);

Vue.observable({ auth: AuthService });

export const bus = new Vue();

const main = async () => {
  await AuthService.init();

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  })
  .$mount('#app')
};

main();